import { awsRoleName } from "@p0security/integrations-aws-shared/policy/shared";
import type { DevEnv } from "@p0security/shared/types/environment";

export const installTf = (context: DevEnv, locals: { vpcId: string }) => {
  const iamRole = awsRoleName(context, "iam-write");
  return `
module "aws_rds_vpc" {
  source  = "p0-security/p0-rds-vpc/aws"
  version = "0.1.3"

  aws_role_name = "${iamRole}"
  vpc_id        = "${locals.vpcId}"
}
`.trim();
};
